import { request } from '@/utils'

interface SchemaParams {
  path: string
  query?: string
  envVersion?: string
}

export type Period = 'one' | 'two' | 'three'

export const getSchemaUrl = async (data: SchemaParams) => {
  return await request({ method: 'POST', url: '/wechat/generateScheme', data })
}

export const getPrizeInfo = async (data: { couponPeriod: Period }) => {
  return await request({ method: 'POST', url: '/wechat/cp/couponStatus', data })
}

export const receivePrize = async (data: { couponPeriod: Period }) => {
  return await request({ method: 'POST', url: '/wechat/cp/activateCoupon', data })
}

// 获取配置信息
export const getWxConfig = async () => {
  return await request({ method: 'GET', url: '/wechat/cp/config' })
}
